import { styled } from "styled-components";

export const DropdownLabel = styled.label`
  margin-right: 5px;
  font-size: 24px;
  padding: 5px;
`;
